export { default } from './SignUp';



// WEBPACK FOOTER //
// ./src/components/UserAccount/SignUp/index.js